import template from './item.all.html';
import controller from './item.all.controller';
import './item.all.scss';

let itemallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default itemallComponent;


// WEBPACK FOOTER //
// ./client/app/components/item/all/item.all.component.js